let loadjs_cache = {};
export function loadjs(url) {
	if (loadjs_cache[url]) return loadjs_cache[url];
	return (loadjs_cache[url] = new Promise(function (resolve, reject) {
		var script = document.createElement("script");
		script.type = "text/javascript";
		script.async = true;
		script.onload = resolve;
		script.onerror = function (err) {
			delete loadjs_cache[url];
			reject(err);
		};
		script.src = url;
		document.body.appendChild(script);
	}));
}

const iswx = navigator.userAgent.toLowerCase().indexOf("micromessenger") >= 0;

export const ua = {
	iswx,
	wx: iswx && "wx" in window,
	ismb: /android|iphone|symbianos|windows phone|ipad|ipod/.test(navigator.userAgent.toLowerCase()),
	baseURL:
		location.protocol +
		"//" +
		location.host +
		(location.port ? ":" + location.port : location.port),
};

/**
 * @param {HTMLElement} el
 * @param {string} cls
 */
export function animate(el, cls) {
	return new Promise(function (resolve) {
		el.classList.add(cls);
		el.classList.add(cls + "-active");
		setTimeout(function () {
			var styl = window.getComputedStyle(el);
			var delays = (styl.transitionDelay || styl.webkitTransitionDelay || "").split(", ");
			// @ts-ignore
			var durations = (styl.transitionDuration || styl.webkittransitionDuration || "").split(", ");
			var ms =
				delays.concat(durations).reduce(function (a, b) {
					return a + parseFloat(b) || 0;
				}, 0) * 1000;
			el.classList.replace(cls, cls + "-to");
			setTimeout(function () {
				el.classList.remove(cls + "-to");
				el.classList.remove(cls + "-active");
				resolve();
			}, ms);
		});
	});
}

/**
 * @param {string} dataurl
 */
function dataURLtoBlob(dataurl) {
	var arr = dataurl.split(","),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n);
	while (n--) u8arr[n] = bstr.charCodeAt(n);
	return new Blob([u8arr], {type: mime});
}

/**
 * 保存文件
 * @param {string|Blob} txt
 * @param {string} [name]
 * @param {boolean} [newWindow]
 */
export function download(txt, name, newWindow) {
	if (/^(blob|https?):/.test(txt)) {
		var a = document.createElement("a");
		a.href = txt;
		if (newWindow) {
			a.target = "_blank";
			a.rel = "noopener noreferrer";
		}
		a.download = name;
		a.click();
		return;
	}
	if (txt == "[object Blob]") return download(URL.createObjectURL(txt), name);
	if (/^data:/.test(txt)) return download(dataURLtoBlob(txt), name);
	return download(new Blob([txt]), name);
}
/**
 * 复制字符串并返回是否复制成功
 * @param {string} str
 */
export function copy(str) {
	str = typeof str === "string" ? str : JSON.stringify(str);
	var success = false;
	try {
		var input = document.createElement("textarea");
		input.style.position = "fixed";
		input.style.top = "-100px";
		input.value = str;
		document.body.appendChild(input);
		input.select();
		input.setSelectionRange(0, str.length);
		success = document.execCommand("copy");
		document.body.removeChild(input);
	} catch (error) {}
	return success;
}

/**
 * 选中节点
 * @param {HTMLElement} el
 */
export function selectNode(el) {
	let selection = window.getSelection();
	selection.empty();
	let range = document.createRange();
	range.selectNode(el);
	selection.addRange(range);
}

/**
 * 获取文件
 * @template T extends boolean
 * @param {string} [accept] 'image/png'
 * @param {T} [multiple=false]
 * @returns {Promise<T extends true ? FileList : File>}
 */
export function pick(accept, multiple) {
	return new Promise(function (resolve, reject) {
		var input = document.createElement("input");
		input.type = "file";
		input.multiple = multiple;
		input.accept = accept == "image" ? "image/png|image/jpeg|image/gif" : accept;
		input.onchange = function (e) {
			// @ts-ignore
			resolve(multiple ? e.target.files : e.target.files[0]);
		};
		input.click();
		input.onabort = reject;
		input.oncancel = reject;
	});
}
/**
 * 读取文件
 * @param {File} file
 * @param {"ArrayBuffer"|"BinaryString"|"DataURL"|"base64"|"utf8"} [encoding]
 * @returns {Promise<string | ArrayBuffer>}
 */
export function readFile(file, encoding) {
	return new Promise(function (resolve, reject) {
		var reader = new FileReader();
		if (encoding && reader["readAs" + encoding]) reader["readAs" + encoding](file);
		else reader.readAsText(file, encoding);
		reader.onload = function (e) {
			resolve(e.target.result);
		};
		reader.onerror = reject;
	});
}

/**
 * @returns {Promise<string>}
 */
export function pickImage() {
	return pick("image").then(function (file) {
		return readFile(file, "DataURL");
	});
}

/**
 *
 * @param {HTMLImageElement} image
 */
export function toCanvas(image) {
	var canvas = document.createElement("canvas");
	canvas.width = image.width;
	canvas.height = image.height;
	var ctx = canvas.getContext("2d");
	ctx.drawImage(image, 0, 0);
	return canvas;
}

/**
 * @param {HTMLCanvasElement} canvas
 * @param {string} [type]
 * @param {any} [quality]
 */
export function toBlob(canvas, type, quality) {
	return new Promise(function (resolve, reject) {
		canvas.toBlob(resolve, type, quality);
	});
}

/**
 * 从URL中加载图片
 * @param {string} url
 * @returns {Promise<HTMLImageElement>}
 */
export function loadImage(url) {
	return new Promise(function (resolve, reject) {
		var img = document.createElement("img");
		img.src = url;
		img.onload = resolve.bind(this, img);
		img.onerror = reject;
	});
}

/**
 * 从URL中加载图片
 * @param {string} url
 * @returns {Promise<HTMLImageElement>}
 */
export function loadImageAsDataURL(url) {
	return new Promise(function (resolve, reject) {
		var img = document.createElement("img");
		img.src = url;
		img.onload = resolve.bind(this, img);
		img.onerror = reject;
	})
		.then(toCanvas)
		.then((canvas) => canvas.toDataURL("png"));
}

/**
 * @param {HTMLImageElement} img
 */
export function readImageData(img) {
	var canvas = document.createElement("canvas");
	canvas.width = img.naturalWidth;
	canvas.height = img.naturalHeight;
	var ctx = canvas.getContext("2d");
	ctx.drawImage(img, 0, 0);
	return ctx.getImageData(0, 0, canvas.width, canvas.height);
}

/**
 *
 * @param {HTMLElement} e
 * @param {HTMLElement} p
 */
export function isParent(e, p) {
	while (e && e.parentNode != p) e = e.parentNode;
	return e;
}

/**
 *
 * @param {CanvasImageSource} img
 * @param {Rect} rect
 * @param {string} [bgColor]
 */
export function crop(img, rect, bgColor) {
	var canvas = document.createElement("canvas");
	canvas.width = rect.width;
	canvas.height = rect.height;
	var ctx = canvas.getContext("2d");
	if (bgColor) {
		ctx.fillStyle = bgColor;
		ctx.fillRect(0, 0, canvas.width, canvas.height);
	}
	ctx.drawImage(img, -rect.x, -rect.y);
	return canvas;
}

export function loadFont(name, timeout) {
	timeout = timeout || 30e3;
	return new Promise(function (resolve, reject) {
		var span = document.createElement("span");
		span.innerText = "你好giItT1WQy@!-/#";
		span.style.fontSize = "300px";
		span.style.fontFamily = "sans-serif";
		span.style.position = "fixed";
		span.style.top = "-10000px";
		document.body.appendChild(span);
		var w = span.clientWidth;
		span.style.fontFamily = name;
		var b = +new Date();
		var h = setInterval(() => {
			if (+new Date() - b > timeout) {
				reject();
				document.body.removeChild(span);
				clearTimeout(h);
			} else {
				if (w != span.clientWidth) {
					resolve();
					document.body.removeChild(span);
					clearTimeout(h);
				}
			}
		}, 100);
	});
}

// export function resize(img, max, fit, bgColor) {
// 	var canvas = document.createElement("canvas");
// 	canvas.width = max.width;
// 	canvas.height = max.height;
// 	var width = img.naturalWidth || img.width;
// 	var height = img.naturalHeight || img.height;
// 	var size = {width, height};
// 	contain(size, max);
// 	if (fit) {
// 		canvas.width = size.width;
// 		canvas.height = size.height;
// 	}
// 	var x = (canvas.width - size.width) / 2;
// 	var y = (canvas.height - size.height) / 2;
// 	var ctx = canvas.getContext("2d");
// 	if (bgColor) {
// 		ctx.fillStyle = bgColor;
// 		ctx.fillRect(0, 0, canvas.width, canvas.height);
// 	}
// 	ctx.drawImage(img, x, y, size.width, size.height);
// 	return canvas;
// }

export function flipX(img) {
	var canvas = document.createElement("canvas");
	var ctx = canvas.getContext("2d");
	canvas.width = img.naturalWidth || img.width;
	canvas.height = img.naturalHeight || img.height;
	ctx.transform(-1, 0, 0, 1, canvas.width, 0);
	ctx.drawImage(img, 0, 0);
	return canvas;
}

export function flipY(img) {
	var canvas = document.createElement("canvas");
	var ctx = canvas.getContext("2d");
	canvas.width = img.naturalWidth || img.width;
	canvas.height = img.naturalHeight || img.height;
	ctx.transform(1, 0, 0, -1, 0, canvas.height);
	ctx.drawImage(img, 0, 0);
	return canvas;
}

/**
 * @param {HTMLImageElement} img
 * @param {number} deg
 */
export function rotate(img, deg) {
	var canvas = document.createElement("canvas");
	var ctx = canvas.getContext("2d");
	var w = img.naturalWidth || img.width;
	var h = img.naturalHeight || img.height;
	var n = Math.sqrt(w * w + h * h);
	canvas.width = canvas.height = n;
	var x = (n - w) / 2;
	var y = (n - h) / 2;
	ctx.translate(n / 2, n / 2);
	ctx.rotate((deg / 180) * Math.PI);
	ctx.drawImage(img, x - n / 2, y - n / 2);
	var scale = img.width / img.naturalWidth;
	var rect = img.getBoundingClientRect();
	var rw = rect.width / scale;
	var rh = rect.height / scale;
	return crop(canvas, {
		x: (n - rw) / 2,
		y: (n - rh) / 2,
		width: (n + rw) / 2,
		height: (n + rh) / 2,
	});
}

export function addText(img, o) {
	var canvas = document.createElement("canvas");
	var ctx = canvas.getContext("2d");
	var w = (canvas.width = img.naturalWidth || img.width);
	var h = (canvas.height = img.naturalHeight || img.height);
	ctx.drawImage(img, 0, 0);
	ctx.font = ((16 / 240) * 400).toFixed(2) + "px Arial";
	ctx.strokeStyle = ctx.fillStyle = o.color || "#fff";
	var m = ctx.measureText(o.text);
	var x = (w - m.width) / 2;
	ctx.fillText(o.text, x, h - 12);
	return canvas;
}

export function measure(el) {
	var styl = window.getComputedStyle(el);
	var paddingLeft = parseFloat(styl.paddingLeft) || 0;
	var paddingRight = parseFloat(styl.paddingRight) || 0;
	var paddingTop = parseFloat(styl.paddingTop) || 0;
	var paddingBottom = parseFloat(styl.paddingBottom) || 0;
	var borderLeft = parseFloat(styl.borderLeft) || 0;
	var borderRight = parseFloat(styl.borderRight) || 0;
	var borderTop = parseFloat(styl.borderTop) || 0;
	var borderBottom = parseFloat(styl.borderBottom) || 0;
	var width = el.clientWidth - paddingLeft - paddingRight;
	var height = el.clientHeight - paddingTop - paddingBottom;
	return {
		paddingLeft,
		paddingRight,
		paddingTop,
		paddingBottom,
		borderLeft,
		borderRight,
		borderTop,
		borderBottom,
		width,
		height,
	};
}

export function os(ua) {
	ua = ua || navigator.userAgent;
	let oss = {
		微信: /micromessenger/i,
		WP: /windows phone/i,
		Mac: /os x/i,
		Android: /Android/i,
		Linux: /linux/i,
		iPhone: /\(iPhone.*os (\d+)[._](\d+)/i,
		iPad: /\(iPad.*os (\d+)[._](\d+)/i,
		iOS: /ios/i,
		ChromeOS: /cros/i,
		Windows10: /windows nt 10\.0/i,
		Windows8: /windows nt 6\.[23]/i,
		Windows7: /windows nt 6\.1/i,
		WindowsVista: /windows nt 6\.0/i,
		Windows2003: /windows nt 5\.2/i,
		WindowsXP: /windows nt 5\.1/i,
		Windows2000: /windows nt 5\.0/i,
		Windows: /windows nt/i,
		Wii: /wii/i,
		PS3: /playstation 3/i,
		PSP: /playstation portable/i,
		Bada: /Bada\/(\d+)\.(\d+)/i,
		Curl: /curl\/(\d+)\.(\d+)\.(\d+)/i,
	};
	for (let k in oss) {
		let v = oss[k];
		if (v.test(ua)) return k;
	}
	return "未知";
}
